import React from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Switch,
  FormHelperText,
} from "@material-ui/core";

/**
 * Renderiza um campo de formulário baseado no schema do plugin.
 *
 * Props:
 * - field: { name, label, type, helpText, placeholder, options, defaultValue, required, validation }
 * - value: valor atual do campo
 * - onChange: (name, value) => void
 * - error: string de erro (opcional)
 */
const ChannelFieldRenderer = ({ field, value, onChange, error }) => {
  const handleChange = (e) => {
    const val = field.type === "switch" ? e.target.checked : e.target.value;
    onChange(field.name, val);
  };

  if (field.type === "switch") {
    return (
      <FormControlLabel
        style={{ marginTop: 8 }}
        control={
          <Switch
            color="primary"
            checked={!!value}
            onChange={handleChange}
          />
        }
        label={field.label}
      />
    );
  }

  if (field.type === "select") {
    return (
      <FormControl
        variant="outlined"
        margin="dense"
        fullWidth
        error={!!error}
      >
        <InputLabel>{field.label}</InputLabel>
        <Select
          value={value || field.defaultValue || ""}
          onChange={handleChange}
          label={field.label}
        >
          {(field.options || []).map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
        {(error || field.helpText) && (
          <FormHelperText>{error || field.helpText}</FormHelperText>
        )}
      </FormControl>
    );
  }

  return (
    <TextField
      label={field.label}
      name={field.name}
      type={field.type === "password" ? "password" : field.type === "number" ? "number" : "text"}
      variant="outlined"
      margin="dense"
      fullWidth
      multiline={field.type === "textarea"}
      rows={field.type === "textarea" ? 4 : undefined}
      placeholder={field.placeholder || ""}
      value={value ?? field.defaultValue ?? ""}
      onChange={handleChange}
      error={!!error}
      helperText={error || field.helpText || ""}
      required={!!field.validation?.required}
    />
  );
};

export default ChannelFieldRenderer;
